import { AgChartOptions } from "@ag-grid-community/core";

export const getPublicCasesCountOptions = (dataIn): AgChartOptions | null => {
  let dataPrepped: any = [];

  if (dataIn) {
    dataIn.forEach((dataPoint) => {
      const preppedPoint = {
        date: new Date(dataPoint.date),
        dayCount: dataPoint.day_count,
        runningCount: dataPoint.running_count,
      };

      dataPrepped.push(preppedPoint);
    });
  }

  const chartOptions: AgChartOptions = {
    autoSize: true,
    series: [
      {
        data: dataPrepped,
        xKey: "date",
        yKey: "runningCount",
      },
    ],
    axes: [
      {
        type: "time",
        position: "bottom",
      },
      {
        type: "number",
        position: "left",
      },
    ],
    // title: {
    //   text: "Participant Count",
    // },
    // subtitle: {
    //   text: "Based on Account Creation Date",
    // },
    background: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    theme: {
      baseTheme: "ag-vivid",
      palette: {
        fills: ["#386968"],
        strokes: ["#1F5755"],
      },
    },
  };

  return chartOptions;
};
